import fetchLinkBlocks from '@nrdy-marketing-engine/internal-links/src/fetch-link-blocks';
import withPageProps from '@nrdy-marketing-engine/server/src/with-page-props';
import { GetStaticPropsContext } from 'next';
import PracticeTestPage from '../../../server/src/practice-test-page';

const canonicalUrl = '/act-practice-tests';

export async function getStaticProps(context: GetStaticPropsContext) {
  const linkBlocks = await fetchLinkBlocks(canonicalUrl);

  return withPageProps(context, {
    linkBlocks,
    canonicalUrl,
    revalidate: 600,
    nspSlug: 'act-practice-tests',
  });
}

export default PracticeTestPage;
